import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";

export const checkAccountStatus = createAsyncThunk(
  "account/checkAccountStatus ",
  async (bodydata, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.checkaccountstatus,
        bodydata
      );
      if (response.status !== 200) {
        return rejectWithValue(response.data);
      }
      return response.data;
    } catch (error) {
      if (error.message) {
        return rejectWithValue(error.response?.data || error.message);
      } else {
        return rejectWithValue({
          msg: "Something went wrong. Please try again later.",
        });
      }
    }
  }
);

const initialState = {
  status: null,
  loading: false,
  error: null,
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkAccountStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkAccountStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.accountStatus = action.payload;
      })
      .addCase(checkAccountStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default accountSlice.reducer;
